import { IIconProps } from '@cian/ui-kit-design-tokens/internal/types';
import * as React from 'react';

export const IconStrokeDislike16 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1188_379876)">
        <path
          d="M3.34297 3H9.99984L9.99984 10.6986L7.44395 14.5527C7.25868 14.832 6.94577 15 6.61055 15H6.49328V11V10H5.49328L1.9756 10C1.26524 10 0.781376 9.28007 1.04967 8.62232L3.34297 3ZM15 10L14 10L14 3H15L15 10Z"
          stroke={currentColor}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1188_379876">
          <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 -1 16 16)" />
        </clipPath>
      </defs>
    </svg>
  );
};
